
  import Vue from 'vue'
import { extractErrorMessage } from '@/utils/Util';
import DeviceShareService from '@/services/DeviceShareService';

  export default Vue.extend({
    name: 'DeviceShareDeleteDialog',

    props: ['deviceshare'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        DeviceShareService.deleteDeviceType(this.deviceshare.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('deviceShare.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("delete", this.deviceshare);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('deviceShare.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
